import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, App } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { BRAND, NEUTRAL, SHADOW } from '../constants/theme';

const { Title, Text } = Typography;

const Login = () => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await authAPI.login(values);
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      message.success('登录成功');
      navigate('/');
    } catch (error) {
      message.error(error.response?.data?.error || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      background: `linear-gradient(135deg, ${BRAND.PRIMARY} 0%, ${BRAND.PRIMARY_DARK} 100%)`,
      padding: '20px'
    }}>
      <Card 
        style={{ 
          width: '100%', 
          maxWidth: 400, 
          boxShadow: SHADOW.LOGIN_CARD,
          borderRadius: '12px'
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>💧</div>
          <Title level={2} style={{ color: BRAND.PRIMARY, marginBottom: '8px' }}>水保数联</Title>
          <Text type="secondary">智能服务平台</Text>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="phone"
            rules={[{ required: true, message: '请输入手机号' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="手机号" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>

          <Form.Item style={{ marginBottom: '24px' }}>
            <Button type="primary" htmlType="submit" loading={loading} block style={{ height: '44px' }}>
              登录
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center', color: NEUTRAL.TEXT_SECONDARY }}>
            还没有账号？ <Link to="/register" style={{ color: BRAND.PRIMARY }}>立即注册</Link>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
